<div class="add-contact-dialog-component gap-16" fxLayout="column">
    @if (loading) {
        <mat-progress-bar
            style="
                width: 100%;
                position: absolute;
                left: 0px;
                top: 0px;
                right: 0px;
            "
            mode="indeterminate"
            color="primary"
        ></mat-progress-bar>
    }

    <div
        fxLayout="row"
        class="add-contact-dialog-component__header"
        fxLayoutAlign="space-between center"
    >
        <h1 class="text-16-semi-bold color-text-primary">
            {{ data.title }}
        </h1>
        <dsn-button-menu-chips
            [mainIcon]="'fa-solid fa-xmark'"
            size="medium"
            (onClick)="this.dialogRef.close()"
        ></dsn-button-menu-chips>
    </div>
    <div fxLayout="column">
        <p class="color-text-primary text-14-regular">{{ data.description }}</p>
    </div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="add-contact-dialog full-width" fxLayout="column">
            <dsn-input
                formControlName="username"
                placeholder="Nome"
                [isInvalid]="
                    form.get('username')?.invalid &&
                    form.get('username')?.touched
                "
                [invalidMessage]="''"
                required
            ></dsn-input>
            <dsn-input
                formControlName="email"
                placeholder="E-mail"
                type="email"
                [isInvalid]="
                    form.get('email')?.invalid && form.get('email')?.touched
                "
                [invalidMessage]="''"
                required
            ></dsn-input>
            <div fxLayout="column" class="gap-4">
                <div fxLayout="row" class="full-width gap-8">
                    @if (data.type === "whatsapp") {
                        <dsn-select
                            placeholder="DDDI"
                            [value]="defaultValue"
                            [disabled]="loading"
                        >
                            @for (prefix of prefixes; track $index) {
                                <dsn-option
                                    [value]="prefix.value"
                                    (onClick)="onChangeDDI(prefix.value)"
                                    >{{ prefix.label }}</dsn-option
                                >
                            }
                        </dsn-select>

                        <dsn-input
                            type="text"
                            class="full-width"
                            [ngxMask]="{
                                mask: currentDdi.mask,
                                showMaskTyped: true
                            }"
                            formControlName="contact"
                            placeholder="Número do WhatsApp"
                            [isInvalid]="
                                form.get('contact')?.invalid &&
                                form.get('contact')?.touched
                            "
                            (onValueChange)="handleValidWhatsapp($event)"
                            [invalidMessage]="''"
                            [noValidate]="true"
                            [required]="true"
                        ></dsn-input>
                    } @else {
                        <dsn-select
                            placeholder="DDDI"
                            value="55"
                            [disabled]="loading"
                        >
                            @for (prefix of prefixes; track $index) {
                                <dsn-option
                                    [value]="prefix.value"
                                    (onClick)="onChangeDDI(prefix.value)"
                                    >{{ prefix.label }}</dsn-option
                                >
                            }
                        </dsn-select>
                        <dsn-input
                            type="text"
                            [ngxMask]="{
                                mask: currentDdi.mask,
                                showMaskTyped: true
                            }"
                            class="full-width"
                            formControlName="contact"
                            placeholder="Número do WhatsApp"
                            [noValidate]="true"
                            [required]="false"
                        ></dsn-input>
                    }
                </div>
                <p
                    class="color-text-medium text-12-regular"
                    style="text-indent: 16px"
                >
                    Ex.: (11) 9 9999-9999
                </p>
            </div>
        </div>
        <div
            class="add-contact-dialog gap-12 m-top-16"
            fxLayout="row"
            fxLayoutAlign="end none"
        >
            <dsn-button
                [prelabel]="''"
                [label]="'Cancelar'"
                (onClick)="dialogRef.close()"
                [type]="'outline'"
                [size]="'medium'"
                [disabled]="loading"
                [iconLeft]="''"
                [iconRight]="''"
                [active]="false"
                [fontWeight]="'bold'"
                [onlyIcon]="''"
            ></dsn-button>
            <dsn-button
                [prelabel]="''"
                [label]="data?.contact?.props?._id ? 'Salvar' : 'Cadastrar'"
                [type]="'primary'"
                [size]="'medium'"
                [disabled]="
                    loading ||
                    form.invalid ||
                    (data.type === 'whatsapp' && isInvalidWhatsapp)
                "
                [iconLeft]="''"
                [iconRight]="''"
                [typeButton]="'submit'"
                [active]="false"
                [fontWeight]="'bold'"
                [onlyIcon]="''"
            ></dsn-button>
        </div>
    </form>
</div>
